// components/Footer.js
import React from "react";

export default function Footer() {
  return (
    <div>
      <footer>
        <small>Step by step, trail by trail, finding peace in the wild.</small>
        <small>👣 🌲 🍂 🦎 🌵 🐢 🍄‍🟫</small>
      </footer>
    </div>
  );
}
